import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import MobileApplicationThemeForm from './MobileApplicationThemeForm';
import { useNavigate, useParams } from 'react-router';
import useCheckPermission from '../../hooks/useCheckPermission';
import publisherService from '../../services/publisherService';
import mobileApplicationThemeService from '../../services/mobileApplicationThemeService';
import tagService from '../../services/tagService';
import moment from 'moment';

const MobileApplicationThemeEdit = (props: any) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const params = useParams();
  const [errors, setErrors] = useState<string[]>([]);
  const [existingThemes, setExistingThemes] = useState<any[]>([]);
  const [entity, setEntity] = useState<any>({
    id: 0,
    logoId: 0,
    backgroundImageId: 0,
    primaryColor: '#000000',
    secondaryColor: '#000000',
    iconPrimaryColor: '#000000',
    iconSecondaryColor: '#000000',
    illustrationPrimaryColor: '#000000',
    startDate: null,
    endDate: null,
  });

  const { checkPermission } = useCheckPermission();
  const [publishers, setPublishers] = useState<any[]>([]);
  useEffect(() => {
    dispatch({ type: 'SHOW_QUERY' });
    publisherService
      .list()
      .then((response: any) => {
        if (!response.hasError) {
          setPublishers(response.records);
        } else
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
      })
      .finally(() => dispatch({ type: 'HIDE' }));
  }, []);

  useEffect(() => {
    mobileApplicationThemeService.get(params.id).then((response: any) => {
      if (response.hasError) {
        setErrors(response.errorMessages);
        enqueueSnackbar(response.errorMessages.join(','), {
          variant: 'error',
        });
      } else {
        setEntity({
          ...response.result,
          startDate: moment(response.result.startDate),
          endDate: moment(response.result.endDate),
        });
      }
    });
  }, [params.id]);

  useEffect(() => {
    dispatch({ type: 'SHOW_QUERY' });
    mobileApplicationThemeService
      .list()
      .then((response) => {
        if (!response.hasError) {
          setExistingThemes(response.records);
        } else
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
      })
      .finally(() => dispatch({ type: 'HIDE' }));
  }, []);

  const onSubmit = (entity: any, setSubmitting: any) => {
    dispatch({ type: 'SHOW_SAVE' });
    mobileApplicationThemeService
      .update(entity)
      .then((response) => {
        if (response.hasError) {
          setErrors(response.errorMessages);
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
        } else {
          enqueueSnackbar('Success!', {
            variant: 'success',
          });

          navigate(-1);
        }
      })
      .finally(() => {
        dispatch({ type: 'HIDE' });
        if (setSubmitting) setSubmitting(false);
      });
  };

  return (
    <MobileApplicationThemeForm
      entity={entity}
      readonly={!checkPermission(['UpdateMobileApplicationTheme'])}
      onSubmit={onSubmit}
      handleCancel={() => navigate(-1)}
      errors={errors}
      publishers={publishers}
      existingThemes={existingThemes}
    />
  );
};

export default MobileApplicationThemeEdit;
